import { Checkbox } from '@trackman/web-shared-components';
import { Paragraph } from 'components/TextComps/Paragraph';

export const EventVisibility = ({
  visible,
  isRecordingReady,
  setVisible,
  setIsRecordingReady,
  setVideoId,
  setVideoUrl,
  setVideoLengthHours,
  setVideoLengthMinutes,
  setPreviewImageData
}: {
  visible: boolean;
  isRecordingReady: boolean;
  setVisible: (value: boolean) => void;
  setIsRecordingReady: (value: boolean) => void;
  setVideoId: (value: string) => void;
  setVideoUrl: (value: string) => void;
  setVideoLengthHours: (value: string) => void;
  setVideoLengthMinutes: (value: string) => void;
  setPreviewImageData: (value: File | null) => void;
}) => {
  return (
    <div className='admin-edit-section'>
      <h2>Settings</h2>
      <div className='checkboxes-container checkbox-with-hint'>
        <Checkbox label='Visible' onChange={() => setVisible(!visible)} checked={visible} />
        <Paragraph>
          <span className='helper-txt'>When the Event ends, it will be automatically hidden.</span>
        </Paragraph>
      </div>
      <div className='checkboxes-container'>
        <Checkbox
          label='Recording ready'
          onChange={() => {
            setIsRecordingReady(!isRecordingReady);
            setVideoId('');
            setVideoUrl('');
            setVideoLengthHours('');
            setVideoLengthMinutes('');
            setPreviewImageData(null);
          }}
          checked={isRecordingReady}
        />
      </div>
    </div>
  );
};
